const initialState = () => ({
  actionPlanHeader: null,
});

const state = initialState();

export default state;
